module.exports = __webpack_public_path__ + "static/room-b16b16145747a43eadc9a09d89041d1e.jpg";